/**
 * @generated SignedSource<<184d768718459336a57efca1f8717cbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ClaimDeviceInput = {
  applianceName: string;
  applianceSerial?: string | null;
  deviceId?: string | null;
  token?: string | null;
};
export type DeviceClaim_claimDevice_Mutation$variables = {
  input: ClaimDeviceInput;
};
export type DeviceClaim_claimDevice_Mutation$data = {
  readonly claimDevice: {
    readonly appliance: {
      readonly id: string;
    };
  } | null;
};
export type DeviceClaim_claimDevice_Mutation = {
  response: DeviceClaim_claimDevice_Mutation$data;
  variables: DeviceClaim_claimDevice_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ClaimDevicePayload",
    "kind": "LinkedField",
    "name": "claimDevice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Appliance",
        "kind": "LinkedField",
        "name": "appliance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeviceClaim_claimDevice_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeviceClaim_claimDevice_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "01860aead059f2da2ad8a48c1d8d2185",
    "id": null,
    "metadata": {},
    "name": "DeviceClaim_claimDevice_Mutation",
    "operationKind": "mutation",
    "text": "mutation DeviceClaim_claimDevice_Mutation(\n  $input: ClaimDeviceInput!\n) {\n  claimDevice(input: $input) {\n    appliance {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "667c85851cda635cc05ed56e245d8476";

export default node;
